import { Container } from 'react-bootstrap';
import React from 'react';
import '../about/About.css';

const FuturePlans = () => (
  <Container>
    <div className="about-page">
      <h1>Objectives / Future Plans </h1>
      <ul>
        <li>
          Merchandising and Market integration of independent vendors by
          building virtual to physical Bitcoin circular economies
        </li>
        <li>
          Media and newsletters covering events and news around psilocybin
          decriminalization
        </li>
        <li>
          Psitadel Bounty Board to complete tasks both digitally and physically
        </li>
        <li>
          Provide members with unique experiences and ticketing utilizing
          Bitcoin technologies
        </li>
        <li>
          Membership and member’s lounge that provides information and access to
          events
        </li>
        <li>
          Educational and skills trade functions that promote jobs development
        </li>
        <li>
          Community co-operative farm that grows plant and fungal medicines for
          member events
        </li>
        <li>
          Biomass gasifier off-grid generator to provide energy to Bitcoin
          miners that provide heat to grow and dry mushrooms
        </li>
      </ul>
    </div>
  </Container>
);

export default FuturePlans;
